import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

export const InputAdormentStyles = (theme: Theme) => createStyles({
    root: {
    },

    container: {
        position: 'relative',
    },

    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(),
        left: 0,
        right: 0,
    },

    inputRoot: {
        color: 'inherit',
        flexWrap: 'wrap',
    },

    inputInput: {
        width: "auto",
        flexGrow: 1
    },

    divider: {
        height: theme.spacing(2),
    },

    loadMore: {
        fontSize: theme.typography.caption.fontSize,
        color: theme.typography.caption.color
    }
});